// CollapseToggle — runder Chevron-Knopf zum Ein-/Ausklappen. Lag bis zuletzt
// modul-privat in DashboardShared; die Speicherleiste der Kundenakte braucht
// denselben Knopf, nur nach oben öffnend.

import * as React from "react";
import { ChevronUp20Regular, ChevronDown20Regular } from "@fluentui/react-icons";
import { REFINED } from "../risikoanalyseStep/tokens";

export interface CollapseToggleProps {
  collapsed: boolean;
  onToggle: () => void;
  /** Was hier ein-/ausgeklappt wird — geht in aria-label und Tooltip ein. */
  label: string;
  /**
   * Wohin sich der Inhalt öffnet: Dashboard-Karten wachsen nach unten, die
   * Speicherleiste am unteren Rand nach oben. Der Chevron muss in die Richtung
   * zeigen, in die der Klick den Inhalt bewegt.
   */
  richtung?: "unten" | "oben";
  disabled?: boolean;
  /** Ersetzt den Standard-Tooltip — etwa um eine Sperre zu begründen. */
  title?: string;
}

/** Runder, transparenter Chevron-Button — steht im Header immer ganz rechts. */
export const CollapseToggle: React.FC<CollapseToggleProps> = ({
  collapsed,
  onToggle,
  label,
  richtung = "unten",
  disabled,
  title,
}) => {
  const zeigtNachOben = richtung === "oben" ? collapsed : !collapsed;
  return (
    <button
      type="button"
      onClick={onToggle}
      disabled={disabled}
      aria-expanded={!collapsed}
      aria-label={collapsed ? `${label} ausklappen` : `${label} einklappen`}
      title={title ?? (collapsed ? "Ausklappen" : "Einklappen")}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 32,
        height: 32,
        flexShrink: 0,
        borderRadius: 999,
        border: "none",
        background: "transparent",
        cursor: disabled ? "not-allowed" : "pointer",
        color: REFINED.ink3,
        opacity: disabled ? 0.45 : 1,
        padding: 0,
      }}
    >
      {zeigtNachOben ? <ChevronUp20Regular /> : <ChevronDown20Regular />}
    </button>
  );
};

export default CollapseToggle;
